
import React from "react";
import { MapPin, Heart, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";



export default function SelectLocationToWork() {
    const navigate = useNavigate();
    const handleChangeCity = () => {
        navigate("/state-selector"); // Assuming you have a route for state selection
    };
    
    const handleContinue = () => {
        alert("Continue button clicked!");
    };
    
    return (
        <div className="min-h-screen bg-gradient-to-b from-[#6c548f] to-[#d97aff] flex flex-col justify-between text-black font-satoshi">
            {/* Top section */}
            <div className="p-6 text-white text-center">
                <h1 className="font-bold mb-2 sm:text-sm md:text-xl">Welcome To ClaimPro</h1>
            </div>

            <div className="bg-white rounded-t-3xl -mt-4 flex-1 flex-col items-center">
                <div className="relative w-full ">
                    <img src="https://camo.githubusercontent.com/e0debd25d05c84be78d89bf7a2858c65e3cfecd72e95bd22ec50e85fa1f84cfb/68747470733a2f2f322e62702e626c6f6773706f742e636f6d2f2d574f70483738393364526b2f5733527372626f476678492f41414141414141414356552f767a6b39683975526262415777485633366a5455644b4f555552795946322d6167434c63424741732f73313630302f73637265656e73686f74362e706e67"
                        alt="" className="w-full rounded-xl h-48 object-cover" />
                    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black text-white px-4 py-1 rounded-full text-sm shadow-lg">
                        All Over India
                    </div>
                </div>


                <div className="text-center mt-6">
                    <p className="text-black font-bold">Earn More Than You Do!</p>
                </div>

                <div className="w-full mt-6">
                    <p className="text-[0.8rem] text-center border-t border-gray-200 pt-4 mb-4">Extra Benefit </p>
                    <div className="flex flex-col items-center space-x-3">
                        <div className="flex items-center gap-2">
                        <div className="relative">
                            <Heart className="text-[#00bdff]" />
                            <CheckCircle className="absolute -top-1 -right-2 bg-white rounded-full text-green-500 w-4 h-4" />
                        </div>
                            <p className="font-semibold text-black ml-2">Upto ₹50,000 per month</p>
                        </div>
                            <p className="text-sm text-gray-600">Going to earn more than current earnings</p>
                    </div>
                </div>
            </div>
            <div className="text-center py-4 bg-white">
             
                <button
                    onClick={()=> navigate("/AddVehiclesVendorMaster")} // Navigate to the next page
                    className="w-[90%] bg-[#00bdff] text-white py-3 rounded-xl font-semibold text-lg mx-auto block"
                >
                    Continue
                </button>
            </div>
        </div>
    )
}